import React from 'react';
import ClassAssembly9B from 'views/ClassAssembly9B';

const ClassAssembly9BPage = () => {
    return <ClassAssembly9B />;
  };
  
  export default ClassAssembly9BPage;

  //9B